import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=1c87fe06&"
import script from "./CardContainer.vue?vue&type=script&lang=js&"
export * from "./CardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports